import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';
import { GET_PLACE_ID } from './constants';
import type { Place } from '@/_types/places';
import type { BaseRequestResponse } from '@/_types/services';

type GetPlaceByIdParams = {
  placeId: string;
};

const getPlaceById = (params: GetPlaceByIdParams) => {
  const { placeId } = params;

  return apiClient
    .get<BaseRequestResponse<Place>>(`/estabelecimentos/${placeId}`)
    .then(response => response.data.data)
    .catch(handleResponseThrowError('Estabelecimento não encontrado'));
};

type GetPlaceByIdResponse = Awaited<ReturnType<typeof getPlaceById>>;

export const useGetPlaceById = (
  params: GetPlaceByIdParams,
  options: Omit<
    UseQueryOptions<
      GetPlaceByIdResponse,
      unknown,
      GetPlaceByIdResponse,
      (string | GetPlaceByIdParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_PLACE_ID, params],
    queryFn: () => getPlaceById(params),
    staleTime: Infinity,
    ...options,
  });
};
